import { useQuery } from '@apollo/client';
import {
  PendingPrescriptionsQueryResponse,
  pendingPrescriptions,
} from '@queries/order/queries/pendingPrescriptions';
import { UploadImage } from '@screens/prescription/components/UploadImage';

interface PendingPrescriptionsProps {
  title: string;
  hasInsurance: boolean;
  error: boolean;
  setError: (boolean) => void;
}
export function PendingPrescriptions(props: PendingPrescriptionsProps) {
  const { title, hasInsurance, error, setError } = props;
  const { data: prescriptionsData } =
    useQuery<PendingPrescriptionsQueryResponse>(pendingPrescriptions(), {
      fetchPolicy: 'cache-and-network',
    });

  return (
    <>
      <UploadImage
        title={title}
        insuranceText={hasInsurance}
        confirmText
        emptyError={error}
        setError={setError}
        data={{
          currentUserInfo: null,
          pendingPrescriptions: prescriptionsData?.pendingPrescriptions ?? [],
        }}
      />
    </>
  );
}
